// 匹配双字节字符，包含汉字
export const strWithZhCn = /[^\x00-\xff]/
// 正整数型数字
export const numberOfInt = /^\d+$/
// 匹配多个\n
export const filterLineBreak = new RegExp(/^\n*|\n*$/g)
// 卡券地址
export const couponUrl = new RegExp('^https?://i.snssdk.com/ad/coupon/api/ticket/assign/[0-9]+|^https?://\\w+.snssdk.com/bn/ams/\\w+/\\d+')
// 匹配 url
export const reUrl = new RegExp(
  '^' +
  // protocol identifier
  '(?:(?:https?|ftp)://)' +
  // user:pass authentication
  '(?:\\S+(?::\\S*)?@)?' +
  '(?:' +
  // IP address exclusion
  // private & local networks
  '(?!(?:10|127)(?:\\.\\d{1,3}){3})' +
  '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' +
  '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})' +
  // IP address dotted notation octets
  // excludes loopback network 0.0.0.0
  // excludes reserved space >= 224.0.0.0
  // excludes network & broacast addresses
  // (first & last IP address of each class)
  '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' +
  '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' +
  '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' +
  '|' +
  // host name
  '(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)' +
  // domain name
  '(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*' +
  // TLD identifier
  '(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))' +
  ')' +
  // port number
  '(?::\\d{2,5})?' +
  // resource path
  '(?:/*\\S*)?' +
  '$', 'i'
)

// 淘宝
export const taobaoReg = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*?(taobao|tmall)[.]com/)
// 淘宝短链接
export const taobaoshortReg = new RegExp(/^http(s)?:\/\/(m.tb)[.]cn(\/([0-9a-z_-]+[.])*?)/)
// 流量宝链接
export const liuliangReg = new RegExp(/^http(s)?:\/\/gxb\.mmstat\.com/)
// 京东
export const jdReg = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(jd)[.]com/)
export const jdMobileReg = new RegExp(/^http(?:s)?\:\/\/item\.jd\.com\/(\d+)\.html/g)
export const jdOldOpenUrlReg = new RegExp(/^openjd:\/\//)
// 携程
export const ctripReg = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(ctrip)[.]com/)
// 唯品会
export const vipshopReg = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(vipshop)[.]com/)
// 苏宁
export const suning = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(suning)[.]com/)
// 苏宁 - 基本
export const basicRegEXp = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(dianping)[.]com(\/shop)/)
// 苏宁 - 首页（固定）
export const homePageRegEXp = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(dianping)[.]com(\/\?utm=)(.)*/)
// 苏宁 - 外卖
export const takeOutRegExp = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(dianping)[.]com(\/waimai\/mindex\?utm=)(.)*/)
// 点评
export const dianping = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(dianping)[.]com/)
// 唯品会
export const vipshop = new RegExp(/^vipshop:\/\/\S*/)
// 美团
export const meituan = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(meituan)[.]com/)
// 美团 - 首页
export const meituanIndexReg = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(meituan)[.]com(\?utm_source=)(.)*/)
// 蘑菇街
export const mogujie = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(mogujie)[.]com/)
// 卷皮
export const juanpi = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(juanpi)[.]com/)
// 魅力惠
export const mei = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(mei)[.]com/)
// 聚美 - 极速免税店
export const jumeiJisu = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(jumei)[.]com\/(global)\/(deals)/)
// 聚美 - 首页
export const jumeiShouYe = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(jumei)[.]com/)
// 聚美 - 母婴
export const jumeiMuying = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(jumei)[.]com\/(luxury)\/(indexdeals)/)
// 聚美 - 轻奢
export const jumeiQingshe = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(jumei)[.]com\/(popdeals)/)
// 聚美 - 专场
export const jumeiZhuanchang = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(jumei)[.]com\/(activity)\/(detailv2)/)
// 聚美 - 拼团
export const jumeiYiqituan = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(jumei)[.]com\/(yiqituan)/)
// 聚美 - 产品
export const jumeiChanpin = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(jumei)[.]com\/(product)/)
// 饿了么
export const eleMe = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(ele)[.]me/)
// 58同城
export const tongCheng58 = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(58)[.]com/)
// 苹果 app 下载地址
export const appleAppLink = new RegExp(/^https?:\/\/(itunes|apps)\.apple\.com/)
// 华为商城商详页
export const huaWeiStoreProReg = new RegExp(/^http(s)?:\/\/(m.vmall)[.]com\/product(\/([0-9a-z_-]+[.])*?)/)
// 华为商城活动页
export const huaWeiStoreActReg = new RegExp(/^http(s)?:\/\/([0-9a-z_-]+[.])*(vmall)[.]com(\/([0-9a-z_-]+[.])*?)/)
// 应用包名
export const appPackageReg = new RegExp(/^[\w\.]+$/)
// 鲁班主域校验
export const jinritemaiReg = /^https:\/\/\w+\.jinritemai\.com/
export const snssdkReg = /^https:\/\/\w+\.snssdk\.com/
export const protocalReg = new RegExp(/^http(s)?:\/\//)
// 0~9999999.99的数字
export const floatNumber = /^[0-9]+(.[0-9]+)?$/
// 两位小数
export const twoFloatNumber = /^([0-9][\d]*)(\.[\d]{1,2})?$/
// 大于0整数
export const intNumber = /^\+?[0-9][0-9]*$/
// 0~999999999的数字
export const intHasMaxNumber = /^(\d{1,9})$/